import type React from 'react';

export interface RolGobernanzaItem {
  id: string;
  tipoRol: string;
  puestoTitulo?: string;
  ambito?: string | null;
  nombrePersonalizado?: string | null;
  activo?: boolean;
  organizacion?: { nombre: string };
  departamento?: { nombre: string };
  fechaInicio?: string;
  fechaFin?: string;
}

export interface ActivoItem {
  id: string;
  nombre: string;
  codigo: string;
  estado: string;
}

export interface SelectOpt {
  value: string;
  label: string;
  orgId?: string;
}

export type TabKey =
  | 'datos'
  | 'puesto'
  | 'procesos'
  | 'proyectos'
  | 'centros'
  | 'activos'
  | 'gobernanza';

export function formatDate(d: string | null | undefined): string {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export const tabStyle = (active: boolean): React.CSSProperties => ({
  padding: '8px 16px',
  fontSize: 13,
  fontWeight: active ? 600 : 400,
  color: active ? 'var(--color-secundario)' : '#5A6171',
  background: 'none',
  border: 'none',
  borderBottom: active ? '2px solid var(--color-secundario)' : '2px solid transparent',
  cursor: 'pointer',
  fontFamily: 'inherit',
  transition: 'color 0.15s',
});

export const cardStyle: React.CSSProperties = {
  background: '#fff',
  border: '1px solid #E2E6ED',
  borderRadius: 10,
  padding: 20,
};

export const labelStyle: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  color: '#5A6171',
  marginBottom: 4,
  display: 'block',
};

export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 14px',
  border: '1px solid #D1D5DB',
  borderRadius: 8,
  fontSize: 14,
  fontFamily: 'inherit',
  outline: 'none',
};

export const gridStyle2: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '12px 16px',
};

export const gridStyle3: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: '12px 16px',
};

export const modalOverlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.5)',
  zIndex: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const modalBox: React.CSSProperties = {
  background: '#fff',
  borderRadius: 12,
  borderTop: '3px solid #1F3864',
  maxWidth: 500,
  width: '95%',
  padding: '24px 28px',
  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
};

export const fieldLabel: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  color: '#5A6171',
  display: 'block',
  marginBottom: 4,
};

export const fieldInput: React.CSSProperties = {
  padding: '8px 10px',
  border: '1px solid #D1D5DB',
  borderRadius: 6,
  fontSize: 13,
  width: '100%',
  fontFamily: 'inherit',
  outline: 'none',
  boxSizing: 'border-box' as const,
};

export const btnCancel: React.CSSProperties = {
  padding: '8px 20px',
  background: 'transparent',
  border: '1px solid #D1D5DB',
  borderRadius: 6,
  fontSize: 13,
  cursor: 'pointer',
  fontFamily: 'inherit',
  color: '#374151',
};

export const btnPrimary: React.CSSProperties = {
  padding: '8px 24px',
  background: '#2F5496',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  fontSize: 13,
  fontWeight: 700,
  cursor: 'pointer',
  fontFamily: 'inherit',
};
